/* global translate */
import React from 'react'
import translate from '../../../../classes/lang';
import './poll_item.css';
const { rxaget, stringToColour, rxChangeSlug, subString ,changeColorSVG,autoConvertTime, timeConverter } = global.rootRequire('classes/ulti')
const { checkNameContact, checkNameUser, changeColorAva } = global.rootRequire('classes/chat')
export const renderComponent = (vm) =>{
  let pollInfo = vm.state.pollInfo
  return(
    <div>
    { //pollInfo && pollInfo.poll_id &&
      <div className='zpoll_item_place' onClick={() => {vm.choosePoll()}}>
        <div className='zpoll_item_title'>{pollInfo?.question}</div>
        <div className='zpoll_item_creator'>Bởi {rxaget(pollInfo, 'user_created.full_name', '')} - {timeConverter(rxaget(pollInfo, 'created_at', ''), 'dayminute')}</div>
        <div className='zpoll_item_count-num-place'>
          {pollInfo.status === 2 && <div className='zpoll_item-end-vote'> {translate('Ends at ') + autoConvertTime(rxaget(pollInfo, 'updated_at', '')) }</div>}
          {
            pollInfo.total_user_voted > 0 &&
            <div className='zpoll_item-count-num' onClick={()=>{vm.setState({flagPollItem:true})}}>
              <span>{pollInfo.total_user_voted + translate(' people voted')} </span>
              <img className='zlistpoll-sort-icon' alt='' src={changeColorSVG('./images/default/icons/icon-sort.svg')}/>
              <div>
                
              </div>
            </div>
          }
        </div>

        <div className='zpoll_list'>
          {
            pollInfo.answers &&
            pollInfo.answers.length > 0 &&
            pollInfo.answers.map((ele)=>{
              return(
                <div key={ele.id}>
                  {
                    ele.users.length > 0 ?
                    <div className='zpoll_option_active' >
                      {ele.answer}
                      {/* <div className='zpoll_option-count'>{ele.total_user_voted}</div> */}
                      <div className='zpoll_option-count'>{ele.users.length}</div>
                    </div> 
                    :
                    <div className='zpoll_option' >{ele.answer}</div>
                  }
                </div>
              )    
            })
          }
        </div>
        {
          pollInfo.answers &&
          pollInfo.answers.length > 3 &&
          <div className='zpoll_remain_item_title'>{(pollInfo.answers.length - 3) + translate(' more options')}</div> 
        }
        {
          // vm.props.comp !== 'poll_list_item' &&
          <div className='zpoll_mess_button_place'>
            <div className='zpoll_mess_button'>{vm.getPollBtnTxt(pollInfo)}</div>
          </div>
        }

      </div>
    }
    </div>
    
  )
}
